export function fixRedirect(url: string) {
  if (url.endsWith('/eleves/import')) {
    return url.replace('/eleves/import', '/eleves');
  }
  const programmationPart = 'programmations';
  if (url.includes(`/${programmationPart}/`)) {
    const basePath = url.split(`/${programmationPart}/`)[0];
    return `${basePath}/${programmationPart}`;
  }
  return url;
}
